import Base from "./base.js";
import apiDispatcher from "@/utils/api-dispatcher";
import {
  COLLEGE_EVENT_INDEX,
  COLLEGE_EVENT_SHOW,
  COLLEGE_EVENT_INDEX_V2
} from "@/utils/api-url";

class CollegeEvent extends Base {
  constructor(params = {}) {
    super(params);
    this.id = params["_id"];
    this.key = params["_id"] || this.id || "";
    this.collegeName =
      (params["collegeId"] && params["collegeId"]["collegeName"]) ||
      this.collegeName ||
      "";
    this.eventType =
      (params["eventType"] && params["eventType"]["name"]) ||
      this.eventType ||
      "";
    this.eventName = params["eventName"] || this.eventName || "";
    this.eventId =
      (params["eventType"] && params["eventType"]["_id"]) || this.eventId || "";
    this.date = params["date"] || this.date || "";
    this.time = params["time"] || this.time || "";
    this.datetime = `${new Date(
      this.date
    ).toLocaleDateString()}, ${this.time.toUpperCase()}`;
    this.division =
      (params["division"] && params["division"]["name"]) || this.division || "";
    this.divisionId =
      (params["division"] && params["division"]["_id"]) ||
      this.divisionId ||
      "";
    this.location = params["location"] || this.location || "";
    this.collegeId = params["collegeId"] || this.collegeId || {};
    this.title = params["title"] || this.title || "";
  }

  static resourceName() {
    return "collegeEvent";
  }

  static index(params) {
    const profileId = this.profileId();
    return apiDispatcher(COLLEGE_EVENT_INDEX(params, profileId));
  }

  static indexLimited(params) {
    const profileId = this.profileId();
    return apiDispatcher(
      COLLEGE_EVENT_INDEX({ ...params, limit: 4, page: 1 }, profileId)
    );
  }

  static indexV2(params) {
    const profileId = this.profileId();
    return apiDispatcher(
      COLLEGE_EVENT_INDEX_V2(params.collegeId, profileId, {
        ...params,
        collegeId: null,
        profileId: null
      })
    );
  }

  static show(params) {
    return apiDispatcher(COLLEGE_EVENT_SHOW(params.id, this.profileId()));
  }

  static searchConfig = [
    {
      component: "BaseTaxonomySelect",
      resource: "collegeEventType",
      type: "College Event Type",
      placeholder: "Event Type",
      allowClear: true,
      column: "eventType",
      searchType: "normal",
      gridComponent: "one",
      filterByLabel: ["Game Schedule"]
    },
    {
      component: "BaseSearchSelectCollege",
      valuePath: "id",
      labelPath: "collegeName",
      placeholder: "College Name",
      column: "collegeId",
      searchType: "normal",
      optionFilterProp: "children",
      allowClear: true,
      showSearch: true,
      filterOption: true,
      gridComponent: "two",
      defaultActiveFirstOption: false
    },
    {
      component: "BaseDatePicker",
      placeholder: "Select Date",
      column: "date",
      allowClear: true,
      searchType: "normal",
      valueFormat: "YYYY/MM/DD",
      gridComponent: "three"
    },
    {
      component: "BaseTaxonomySelect",
      resource: "division",
      type: "Division",
      placeholder: "Division",
      allowClear: true,
      column: "division",
      searchType: "normal",
      gridComponent: "five"
    },
    {
      component: "BaseInput",
      placeholder: "City Name",
      column: "q1",
      searchType: "query",
      additionalData: { searchField1: "city" },
      gridComponent: "six"
    },
    {
      component: "BaseSortedTaxonomySelect",
      resource: "collegeState",
      type: "College State",
      placeholder: "State",
      allowClear: true,
      column: "state",
      searchType: "normal",
      gridComponent: "seven",
      optionFilterProp: "children",
      showSearch: true,
      filterOption: true
    },
    {
      component: "BaseInput",
      placeholder: "Address",
      column: "q2",
      searchType: "query",
      additionalData: { searchField2: "location" },
      gridComponent: "eight"
    },
    {
      component: "BaseButton",
      class: "btn btn-default primary-button-extra-class",
      type: "primary",
      searchType: "Submit",
      gridComponent: "eleven",
      label: "Search",
      clickable: true
    }
  ];
}

export default CollegeEvent;
